<template>
	<div class="form-group">
		<label :for="name" :class="{ error: errors.has(name) }">{{ placeholder }}</label>
		<div class="items">
			<label v-for="option in options" :key="option.value" class="item">
				<input type="radio" :name="name" :id="option.text" :value="option.value" v-model="selected" @change="onChange" v-validate="rules" :data-vv-as="placeholder">
				<span class="value">{{ option.text }}</span>
			</label>
		</div>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'value',
		'options',
		'name',
		'placeholder',
		'rules'
	],
	data () {
		return {
			selected: ''
		}
	},
	computed: {
		result () {
			return this.selected ? this.selected : 0
		}
	},
	methods: {
		onChange () {
			this.$emit('input', this.result)
		}
	},
	created () {
		this.options.forEach(element => {
			if (element.value & this.value) {
				this.selected = element.value
			}
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/InputRadio.vue